/**
 * Holds the information about the user
 */

// is populated when used is logged in
var _USER_INFO = null;
var _USER_PUBLIC_ID = null;

function setUserInfo(value) {
    _USER_INFO = value;
}

function setUserPublicId(value) {
    _USER_PUBLIC_ID = value;
}

angular.module('edge.platform.userinfo', [])
/*
 constant method is used to get the user info at the any phase of the app
 */
.constant('USER_INFO', function () {
    if (!_USER_INFO) {
        // shouldn't be called before the user info is assigned
        throw new Error('User info is not provided');
    }
    return _USER_INFO;
}).constant('USER_PUBLIC_ID', function () {
    if (!_USER_PUBLIC_ID) {
        // shouldn't be called before the user info is assigned
        throw new Error('User PublicId is not provided');
    }
    return _USER_PUBLIC_ID;
})

/*
 Helper service for the easier access to the data
 */
.factory('UserInfoService', function () {
    if (!_USER_INFO) {
        return {
            setUserPublicId: setUserPublicId,
            setUserInfo: setUserInfo,
            publicId: _USER_PUBLIC_ID,
            isAgent: function isAgent() {
                return false;
            }
        };
    }

    return {
        setUserPublicId: setUserPublicId,
        setUserInfo: setUserInfo,
        publicId: _USER_PUBLIC_ID,
        isAgent: function isAgent() {
            return _USER_INFO.userType === 'producer';
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/userinfo/module.js
// module id = 1083
// module chunks = 0